export default class ResponsiveVideo {
	constructor(video) {
		this.video = video;
		this.width = this.video.getBoundingClientRect().width * window.devicePixelRatio; // Get width taking pixel density into account
		this.pickSource();
	}

	pickSource() {
		const self = this;
		this.matchedSource = null;
		this.prevDiff = 999999;

		// Loop over all video sources
		this.sourceCount = this.video.children.length;
		this.removedSources = 0;
		const removeSources = new Promise((resolve, reject) => {
			Array.from(this.video.children).forEach(source => {
				// Get source resolution (by provided by data attribute)
				let sourceWidth = source.dataset.sourcewidth;

				// Compare source resolution to video element width
				let currentDiff = sourceWidth - this.width;
				if (currentDiff <= 0) {
					currentDiff = currentDiff * -1;
				}
				if (currentDiff <= this.prevDiff) {
					this.matchedSource = source;
				}
				this.prevDiff = currentDiff;

				setTimeout(() => {
					source.remove();
					this.removedSources++;
					if (this.removedSources >= this.sourceCount) {
						resolve('Removed All Sources');
					}
				}, 0);
			});
		});

		removeSources.then(() => {
			this.video.src = this.matchedSource.src;

			if (this.video.dataset.autoplay) {
				this.video.addEventListener('loadeddata', e => {
					this.video.play();
				});
			}
		});
	}

	playVideo() {
		this.video.play();
	}

	stopVideo() {
		this.video.pause();
	}
}
